import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import { ModalBaseStyles } from "../../../Common/styles/modal";
import { useState } from "react";
import { errorToastMessage, toastMessage } from "../../../../utils/toast";
import http from "../../../../utils/http";
import { useParams } from "react-router-dom";
import { PARTICIPANT_LOCKED_MESSAGE } from "../../../../utils/participantLock";

type Props = {
  show: boolean;
  onClose: () => void;
  data: any;
  refreshPage: () => void;
  participantIdForModal?: string;
  studyId?: string;
  type: "platform" | "study";
  formType: "consent" | "sunshine";
  isLocked?: boolean;
};

const VerifyConsentModal: React.FC<Props> = ({
  formType,
  onClose,
  show,
  data,
  refreshPage,
  participantIdForModal,
  studyId,
  type,
  isLocked = false,
}) => {
  const [isLoading, setLoading] = useState(false);
  const { participantId: pathParticipantId } = useParams();
  const participantId = participantIdForModal || pathParticipantId;

  const handleCancel = () => {
    onClose();
  };

  const handleContinue = async () => {
    if (isLocked) {
      toastMessage("error", PARTICIPANT_LOCKED_MESSAGE);
      return;
    }
    try {
      setLoading(true);
      const prefix =
        type === "platform"
          ? `/platform/admin/econsent/participants/${participantId}/signed-econsents`
          : formType === "sunshine"
          ? `/admin/study/${studyId}/sunshine/participants/${participantId}/signed-sunshine-forms`
          : `/admin/study/${studyId}/econsent/participants/${participantId}/signed-econsents`;

      let res = await http.post(`${prefix}/${data?.id}/verify`);
      toastMessage("success", res.data.message);
      refreshPage();
      onClose();
    } catch (err) {
      errorToastMessage(err as Error);
      setLoading(false);
    }
  };

  return (
    <Modal open={show}>
      <Box
        sx={{ ...ModalBaseStyles, height: "fit-content", minHeight: "20vh" }}
      >
        <Typography
          variant="h2"
          fontWeight="medium"
          mb={1}
          sx={{ color: "primary.main" }}
        >
          Verify {formType === "consent" ? "Consent" : "Form"}
        </Typography>

        <Divider />

        <Typography mt={2} variant="subtitle1">
          I hereby verify the{" "}
          {formType === "consent" ? "ICF Form" : "Sunshine Form"} has been
          completed and signed by the participant.
        </Typography>

        <Stack
          direction="row"
          alignItems={"center"}
          justifyContent={"flex-end"}
          sx={{ marginTop: "10px" }}
          gap={1.5}
        >
          {isLoading ? (
            <CircularProgress color="inherit" size={18} />
          ) : (
            <>
              <Button variant="outlined" onClick={handleCancel}>
                Cancel
              </Button>

              <Button
                variant="contained"
                onClick={handleContinue}
                disabled={isLocked}
                title={isLocked ? PARTICIPANT_LOCKED_MESSAGE : ""}
              >
                Verify
              </Button>
            </>
          )}
        </Stack>
      </Box>
    </Modal>
  );
};

export default VerifyConsentModal;
